module.exports = __webpack_public_path__ + "static/img/4.e7e8e39.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/sp/4.png
// module id = /cHn
// module chunks = 0